
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/pr/[id]",
      function () {
        return require("private-next-pages/news/pr/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/pr/[id]"])
      });
    }
  